export default __webpack_public_path__ + "static/media/icon-hamburger.5153cb80.svg";